import type { IAppSettings } from '../appSettings.types';
import { commonAppSettings } from '../commonAppSettings';

const basename = __BASENAME__ ? `/${__BASENAME__}` : '';

export const preprodAppSettings: IAppSettings = {
  ...commonAppSettings,
  environment: {
    name: 'preprod',
    url: `https://app-preview.crowdaa.com${basename}`,
  },
  enabledRegions: ['crowdaa-dev-us', 'crowdaa-us', 'crowdaa-fr'],
  defaultRegion: 'crowdaa-fr',
  analytics: {
    googleTagManager: {
      enabled: true,
      environment: {
        id: 'GTM-PLPTLHXX',
        auth: 'sosQbIx1F1Sk_7X6CpMWkw',
        preview: 'env-9',
      },
    },
    hotjar: {
      enabled: false,
      siteId: '5015493',
    },
    sentry: {
      enabled: true,
      dsn: 'https://dd4d1632fbfc3c21fd4d52cb0fa27202@o4507388908994560.ingest.de.sentry.io/4507388911222864',
    },
  },
  stripe: {
    billingPortalUrl:
      'https://billing.stripe.com/p/login/test_aEUbJdfUE67Redy6op',
  },
  mapBox: {
    accessToken:
      'pk.eyJ1IjoiY3Iwd2Q0NCIsImEiOiJjbTFvdmdmbXcxNzFuMnRzYjRlYWtpbzNiIn0.c9SSKyAkRkOQ3CrcuWEczA',
    styles: {
      light: 'mapbox://styles/cr0wd44/cm1ozmy4y00pj01pi4n2bfbx1',
      dark: 'mapbox://styles/cr0wd44/cm1ovo6co00oz01pi5wp0h8du',
    },
  },
};
